/** Search outward without clamping different candidates onto the same edge. */
export function clonePositions(
  origin: number,
  size: number,
  width: number,
  limit: number,
): number[] {
  const positions: number[] = [];
  const gap = size * 0.68;
  const margin = size * 0.4;
  for (let step = 1; step <= 3 && positions.length < limit; step++) {
    for (const direction of [-1, 1]) {
      const x = origin + step * gap * direction;
      if (x < margin || x > width - margin) continue;
      positions.push(x);
      if (positions.length === limit) break;
    }
  }
  return positions;
}
